import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PartneroptionsComponent } from 'app/partneroptions/partneroptions.component';
import { ServicefinService } from 'app/services/servicefin.service';
import { ServicepoolService } from 'app/services/servicepool.service';
import { Options } from 'ngx-qrcode-styling';

@Component({
  selector: 'app-paymantmodal',
  templateUrl: './paymantmodal.component.html',
  styleUrls: ['./paymantmodal.component.css']
})
export class PaymantmodalComponent implements OnInit {

    config: Options = {
      width: 200,
      height: 200,
      data: "",
      image: "",
      margin: 5,
      backgroundOptions: {
        color: "#ffffff",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0
      }
    };
  agenceinfos;
  servicePaiement;
  montant;
  frais;
  samacaabiyoonwii;
  numpay;

  etapeverse = 0;

  idchecker : any ;

  retourClientWS : any ;

  etatreq : any ;

  constructor(private configServer: ServicepoolService, public dialogRef: MatDialogRef<PartneroptionsComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any ) { 
    this.agenceinfos = data.opt ;
    console.log(this.agenceinfos) ;
  }


  initierVersementAgent(){
    let param;
    this.etapeverse = 1 ;
    if(this.servicePaiement == "Wave"){
      param ={samacaabiyoonwii:this.samacaabiyoonwii,montant:this.montant+this.frais,paymean:this.servicePaiement,infosup :JSON.stringify({})}
    }else{
      param ={samacaabiyoonwii:this.samacaabiyoonwii,montant:this.montant+this.frais,paymean:this.servicePaiement,infosup :JSON.stringify({numeropay:this.numpay})}
    }
    this.configServer.initierVersementAgent(param).then(res=>{
      console.log(res);
      if(res['statutreq'] == 1){
        if(this.servicePaiement == "Wave"){
          this.config.data = res.data.wavelink;
          this.config.template = "default" ;
          this.config.image = "" ;          
          this.idchecker = res.data.idwaveop ; 
          this.periodicCheckWave() ;         
        }else{
          this.idchecker = res.data.idomop ;  
          this.periodicCheckOM();                  
        }
      }
      
    })
  }

  periodicCheckWave(){
    this.configServer.checkPayStatusWave(this.samacaabiyoonwii, this.idchecker ).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq ;
      if(statutreq==1){ 
        this.etapeverse = 2 ;
        this.etatreq = "successfull" ;
      }else if (statutreq==-1){
        this.etapeverse = 2 ;
        console.log("Echec du Paiement") ;
        this.etatreq = "failed" ;
      }
      else{        
        setTimeout(() => {
            this.periodicCheckWave() ;
        }, 3000);
      }
    }) ;          
  }


  periodicCheckOM(){
    this.configServer.checkPayStatusOM(this.samacaabiyoonwii, this.idchecker ).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq ;
      

      if(statutreq==1){ 
        this.etapeverse = 2 ;
        this.etatreq = "successfull" ;
      }else if (statutreq==-1){
        this.etapeverse = 2 ;
        console.log("Echec du Paiement") ;
        this.etatreq = "failed" ;
      }
      else{        
        setTimeout(() => {
            this.periodicCheckOM() ;
        }, 3000);
      }
    }) ;          
  }


 consulter(){
    window.open(this.config.data ) ;
  }


  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd ;
  }

  ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    this.montant = this.agenceinfos.montant;
    this.frais = this.agenceinfos.frais;
  }

  close(){
    this.dialogRef.close() ;
  }

}
